<template>
  <div class="twitter-poll panel-settings">
  </div>
</template>

<script>
export default {
};
</script>
